import { memo } from 'react'
import { NubsItem, NubsText, VideoWrapper } from './NubsUpload.style'
import VideoThumbnail from '../VideoThumbnail'
import useNubsVideoThumbnail from '../VideoThumbnail/useNubsVideoThumbnail'
import useImageThumbnail from '../ImageThumbnail/useImageThumbnail'
import ImageThumbnailLoader from '../ImageThumbnail/ImageThumbnailLoader'

const NubsVideo = ({ nub, data, isUploading, container }) => {
    const { media_uuid } = nub
    const hookProps = useNubsVideoThumbnail({ key: media_uuid, data })
    return (
        <VideoWrapper>
            <VideoThumbnail isProcessing={isUploading} className="nubs__video-thumbnail" label={'Nubs video'} fullWidth container={container} {...hookProps} />
        </VideoWrapper>
    )
}

const NubsImage = ({ nub, isUploading }) => {
    const { media_url_raw, media_url } = nub
    const imageUrl = media_url_raw || media_url
    const hookProps = useImageThumbnail({ thumb: imageUrl, isLoading: isUploading })
    const imageThumbnailLoaderProps = {
        isLoading: isUploading,
        className: 'nubs__image',
        width: 'full',
        height: 'full',
        src: imageUrl,
        alt: '',
        ...hookProps,

    }
    return (
        <ImageThumbnailLoader {...imageThumbnailLoaderProps} />
    )
}

const Nub = (props) => {
    const { nub, collection, containerRef, className = '', style = {} } = props
    const { chunk, media_uuid, media_url } = nub
    // Content is embeddable and needs to be serve from an iframe
    // when it contains script or iframe tags
    const isEmbeddable = (chunk || '').match('<script|<iframe')
    const isImage = (!!media_uuid && !!media_url) || isEmbeddable
    const content = (chunk || '')
        // (links should be active and pop open new browser)
        .replace(/<a ([^>]*)>([\s\S]*?)<\/a>/g, "<a $1 target=\"_blank\">$2</a>")
        // new lines should be rendered as single-line break tags
        .replace(/\n/g, isEmbeddable ? "\n" : "<br>")
    const RenderItem = () => {
        if (chunk) {
            return isEmbeddable
                ? (
                    <iframe
                        tabIndex={-1}
                        title={`nubs-iframe-${nub.id}`}
                        srcDoc={`
                        <html>
                            <head>
                                <link rel="preconnect" href="https://fonts.googleapis.com">
                                <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
                                <link href="https://fonts.googleapis.com/css2?family=Work+Sans:ital@0;1&display=swap" rel="stylesheet">
                                <style>
                                    html, body {
                                        margin: 0;
                                        font-family: "Work Sans", sans-serif;
                                    }

                                    .html-chunk__container {
                                        min-height: 100%;
                                        max-height: 100%;
                                        display: flex;
                                        flex-direction: column;
                                        justify-content: center;
                                        align-items: center;
                                    }

                                    .html-chunk__container iframe,
                                    .html-chunk__container object { 
                                        max-width: 100%;
                                        max-height: 100vh!important;
                                    }

                                    .html-chunk__container iframe[src*="youtube"] {
                                        height: auto!important;
                                    }

                                    .html-chunk__container iframe[style*="height: 100%"],
                                    .html-chunk__container iframe[style*="height:100%"] {
                                        min-height: 100vh;
                                    }

                                    .html-chunk__container > div[style*="padding"] {
                                        padding: 0!important;
                                    }

                                    .html-chunk__container > div[style*="height"] {
                                        height: 100%!important;
                                    }

                                    .html-chunk__container > div[style*="position"] {
                                        position: static!important;
                                    }

                                    div {
                                        margin: 0 auto;
                                    }
                                </style>
                            </head>
                            <body>
                                <div class="html-chunk__container">
                                    ${content}
                                </div>
                            </body>
                        </html>
                        `}
                    />
                )
                : (
                    <NubsText
                        dangerouslySetInnerHTML={{
                            __html: content,
                        }}
                        container={containerRef?.current}
                    />
                )
        } else if (isImage) {
            return media_url.match(/\.(?:avi|mkv|mov|mp4|webm)$|data:video\/(?:avi|mkv|mov|mp4|webm)/g)
                ? <NubsVideo nub={nub} data={collection} container={containerRef?.current} />
                : <NubsImage nub={nub} />
        } else {
            return null
        }
    }
    return (
        <NubsItem className={`nubs__item ${className}`} container={containerRef?.current} isImage={isImage} style={style}>
            <RenderItem />
        </NubsItem>
    )
}

export default memo(Nub)